
import {
    ApiCall
} from './index';

export const INCIDENT_FORM = (id) => "/incidents/form?site_id="+id;
export const CREATE_INCIDENT = "/incidents";

export const form = async(data) => {
    return await ApiCall('GET', INCIDENT_FORM(data.id), null, false);
};

export const create = async(data) => {
    return await ApiCall('POST', CREATE_INCIDENT, data);
};



// WEBPACK FOOTER //
// ./src/services/incident.js